import React, { useContext, useEffect, useState } from "react";
import { AppBar, Button, Toolbar, Typography } from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import "./Navbar.css";
import { UserContext } from "../../contexts/UserContext";
import axios from "axios";

export default function Navbar() {
	const [screenWidth, setScreenWidth] = useState(undefined);

	const { isLoggedIn, setLoginFalse, userDetails } = useContext(UserContext);

	const [isTestArea, setIsTestArea] = useState(false);

	const history = useHistory();
	const location = useLocation();

	const handleResize = () => {
		setScreenWidth(window.innerWidth);
	};

	const handleLogout = async () => {
		const url = `${process.env.REACT_APP_BACKEND_URL}/user/logout`;

		const data = {
			userId: userDetails._id,
		};

		// console.log(data);

		try {
			await axios.post(url, data).then((res) => {
				// console.log(res);
				history.replace("/");
				localStorage.removeItem("token");
				setLoginFalse();
			});
		} catch (error) {
			// console.log(error);
		}
	};

	useEffect(() => {
		const routes = location.pathname.split("/");

		if (routes[1] === "test") {
			setIsTestArea(true);
		} else {
			setIsTestArea(false);
		}
	}, [location.pathname]);

	useEffect(() => {
		handleResize();
		window.addEventListener("resize", handleResize);
		return function cleanup() {
			window.removeEventListener("resize", handleResize);
		};
	});
	return (
		<>
			<AppBar className="navbar" elevation={2}>
				<Toolbar>
					<Link to={`/`}>
						<img src="/logo.png" alt="logo" className="nav-img" />
					</Link>
					<Typography variant="h5" className="nav-brand">
						{screenWidth > 500 ? "Josh Recruitment Test 2021" : "JRT 2021"}
					</Typography>
					{!isLoggedIn ? (
						<Button component={Link} to="/" className="btn-nav" variant="contained">
							Login
						</Button>
					) : !isTestArea ? (
						<Button onClick={handleLogout} className="btn-nav" variant="contained">
							Logout
						</Button>
					) : (
						<div style={{ width: 70 }}></div>
					)}
				</Toolbar>
			</AppBar>
		</>
	);
}
